import React from 'react';

function Statement() {
  return (
    <section className="py-24 px-4" style={{ backgroundColor: '#0e1e52' }}>
      <div className="max-w-7xl mx-auto">

        <div className="flex flex-col md:flex-row md:items-center md:gap-16">

          {/* Left — big statement */}
          <div className="md:w-1/2">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
              <span className="text-[#ce381b]">Protection,</span> Built Before{' '}
              <span className="text-[#ce381b]">You</span> Need It
            </h2>
          </div>

          {/* Red line — only visible on mobile between the two */}
          <div className="h-0.5 bg-[#ce381b] my-8 md:hidden" />

          {/* Right — small text with red line on desktop */}
          <div className="md:w-1/2">
            {/* Red line — only visible on desktop above subtext */}
            <div className="hidden md:block w-16 h-1 bg-[#ce381b] mb-6" />
            <p className="text-white text-lg sm:text-xl leading-relaxed mb-4">
              We help businesses and individuals navigate risk with the right coverage to prevent a single bad day from becoming a lasting setback.
            </p>

            <p className="text-white text-lg sm:text-xl leading-relaxed mb-4">
              We also approach every engagement differently to accommodate each client's unique needs.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Statement;